import React from 'react';
import moment from 'moment';
import { Paper, Button, Chip, Box } from '@material-ui/core';
import { useHistory } from "react-router-dom";
import { OrderModel } from '../models/order-model';

export const OrderCard = (order: OrderModel) => {
    const history = useHistory();
    const status = (order.status).replace('-', ' ');
    return (
        <Paper elevation={3} style={{ padding: '10px 15px 10px 15px' }}>
            <Box
                style={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'space-between'
                }}
            >
                <h3>#{order.number}</h3>
                <h4><Chip label={status} size="small" style={{ backgroundColor: "#D32F3F", color: "white" }} /></h4>
            </Box>
            <span>{order.userDetails.name}</span>
            <p><small>Entrega estimada para el {moment(order.deliverDate).format('LL')}</small></p>
            <Button
                style={{ fontWeight: 'bolder' }}
                color="secondary"
                onClick={() => history.push(`/orderdetail/${order._id}`)}
            >
                Abrir
            </Button>
        </Paper>
    )
}
